
import { Component, Vue } from "nuxt-property-decorator";
import set from "lodash/set";
import find from "lodash/find";

@Component({
  name: "EmptyLayout",
})
export default class EmptyLayout extends Vue {
  head(): Record<string, unknown> {
    return this.getSeoAtt();
  }

  getSeoAtt(): Record<string, unknown> {
    const i18nAtt = this.$nuxtI18nHead({ addSeoAttributes: true });
    const canonicalObj = find(i18nAtt.link, { rel: "canonical" });
    if (canonicalObj) {
      set(
        canonicalObj,
        ["href"],
        `https://www.commonshare.com${this.$route.path}`
      );
    }
    return i18nAtt;
  }
}
